import { useState, useEffect, useMemo } from 'react';
import { useSearchQuery } from './command-palette.api';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { ISearchResultItem } from '@topshots/core-models';

export function useCommandPaletteSearch(query: string) {
  const [debouncedQuery, setDebouncedQuery] = useState('');

  useEffect(() => {
    if (query.length < 2) {
      setDebouncedQuery('');
      return;
    }
    const timer = setTimeout(() => setDebouncedQuery(query), 300);
    return () => clearTimeout(timer);
  }, [query]);

  const { data, isLoading, isFetching } = useSearchQuery(
    debouncedQuery.length >= 2 ? { q: debouncedQuery } : skipToken
  );

  const results: ISearchResultItem[] = data?.results ?? [];

  const grouped = useMemo(() => {
    const groups: Record<string, ISearchResultItem[]> = {};
    for (const item of results) {
      if (!groups[item.type]) groups[item.type] = [];
      groups[item.type].push(item);
    }
    return groups;
  }, [results]);

  return {
    results,
    grouped,
    isLoading: isLoading || isFetching,
    hasQuery: debouncedQuery.length >= 2,
  };
}
